import React from 'react'

import styled from 'styled-components'

import mediaQueries from 'components/media-queries'

import { TransitionLoader } from '../loaders'
import { parseCmsClass } from './helper_text_rich'

const StyledText = styled.div`
  max-width: ${({ maxWidth }) => maxWidth || '100%'};
  font-family: ${({ theme }) => theme.fonts.regular};
  color: ${({ theme }) => theme.colors.grayScorpion};
  h1 {
    color: ${({ theme }) => theme.colors.blue};
    font-family: ${({ theme }) => theme.fonts.semiBold};
    font-size: 24px;
  }
  h2 {
    color: ${({ theme }) => theme.colors.doveGray};
    font-family: ${({ theme }) => theme.fonts.regular};
    font-size: 18px;
    margin: 15px 0 30px 0;
  }
  ul {
    list-style: none;
    margin: 0 0 30px 30px;
    font-size: 14px;
    ${mediaQueries.tablet`
      margin-left: 30px;
    `};
  }
  ul > li::before {
    content: '•';
    color: ${({ theme }) => theme.colors.blue};
    font-weight: bold;
    display: flex;
    height: 17px;
    font-size: 40px;
    margin-left: -25px;
  }
  ol > li {
    margin-bottom: 15px;
    counter-increment: item;
  }
  li > ol,
  li > ul {
    margin: 15px 0 30px 80px;
  }
  ol {
    list-style: none;
    counter-reset: item;
    margin: 15px 0 30px 30px;
    font-size: 14px;
    ${mediaQueries.tablet`
      margin-left: 35px;
    `};
  }
  ol > li::before {
    margin: 0 10px 0 -30px;
    content: counter(item);
    color: ${({ theme }) => theme.colors.white};
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
    width: 23px;
    height: 23px;
    font-size: 12px;
    float: left;
    font-weight: bold;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.colors.blue};
  }
  ol > li:nth-child(n + 100)::before {
    font-size: 10px;
  }
  img {
    max-width: 100%;
    margin-left: auto;
    margin-right: auto;
    display: block;
  }
  p {
    margin: 10px 0;
    font-size: 14px;
  }
  .img-places {
    display: flex;
  }
  blockquote {
    margin-left: 120px;

    ${mediaQueries.tablet`
      margin-left: 20px;
    `};
  }
  a {
    font-family: ${({ theme }) => theme.fonts.semiBold};
    color: ${({ theme }) => theme.colors.blue};
    &:hover {
      color: ${({ theme }) => theme.colors.blueDark};
    }
  }

  .subtitle-blue {
    color: ${({ theme }) => theme.colors.blue};
    font-family: ${({ theme }) => theme.fonts.semiBold};
    font-size: 24px;
  }
  .text-underlined {
    text-decoration: underline;
  }
  .align-left {
    margin-left: 0;
  }
  .align-right {
    margin-right: 0;
  }
  .text-align-center {
    text-align: center;
  }
  .text-align-right {
    text-align: right;
  }
  .text-align-left {
    text-align: left;
  }
  .text-align-justify {
    text-align: justify;
  }
  .background-light-blue {
    background-color: ${({ theme }) => theme.colors.aliceBlue};
  }
  .background-plus-blue {
    background-color: ${({ theme }) => theme.colors.cms_light_blue};
    color: ${({ theme }) => theme.colors.white};
  }
  .background-white {
    background-color: ${({ theme }) => theme.colors.white};
  }
  .background-cms-blue {
    background-color: ${({ theme }) => theme.colors.cms_blue};
  }
  .background-grey {
    background-color: ${({ theme }) => theme.colors.gainsboro};
  }
  .title-height {
    height: 45px;
  }
  .button {
    background-color: ${({ theme }) => theme.colors.blue};
    color: ${({ theme }) => theme.colors.white};
    text-decoration: none;
    font-family: ${({ theme }) => theme.fonts.regular};
    padding: 9px 30px;
    border-radius: 3px;
    border: none;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }
  .button:hover {
    background-color: ${({ theme }) => theme.colors.blueDark};
    color: ${({ theme }) => theme.colors.white};
  }

  .tableOverflowContainer {
    overflow-x: auto;
  }

  .wrapper-center {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .wrapper-left {
    display: flex;
    align-items: center;
  }

  .wrapper-right {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  table {
    border-collapse: unset;
    border-spacing: 0 6px;
    max-width: 100%;
    border: none;
    font-size: 14px;
    tbody,
    thead {
      width: 100%;
    }
    thead > tr {
      border: none;
      font-family: ${({ theme }) => theme.fonts.semiBold};
      background-color: ${({ theme }) => theme.colors.blue};
      color: ${({ theme }) => theme.colors.white};

      th:first-child {
        overflow: hidden;
        border-top-left-radius: 3px;
        border-bottom-left-radius: 3px;
      }

      th:last-child {
        overflow: hidden;
        border-top-right-radius: 3px;
        border-bottom-right-radius: 3px;
      }
    }
    tr {
      border-radius: 3px;
      border: solid 0.3px #d3d3d3;
      font-family: ${({ theme }) => theme.fonts.regular};
      color: ${({ theme }) => theme.colors.grayScorpion};
      td,
      th {
        flex: 1;
        padding: 10px;
        border: none;
      }
      th {
        font-family: ${({ theme }) => theme.fonts.semiBold};
        background-color: ${({ theme }) => theme.colors.blue};
        color: ${({ theme }) => theme.colors.white};
      }
      td {
        box-shadow: 5px 0 0 0 rgb(255 255 255), 2px 2px 3px 0 ${({ theme }) => theme.shadow.black20};
      }
    }
  }

  tbody > tr:first-child > td {
    box-shadow: 5px 0 0 0 rgb(255 255 255), 2px -2px 3px 0 ${({ theme }) => theme.shadow.black20},
      5px 0 0 0 rgb(255 255 255), 2px 2px 3px 0 ${({ theme }) => theme.shadow.black20};
  }

  thead + tbody > tr:first-child > td {
    box-shadow: 5px 0 0 0 rgb(255 255 255), 2px 2px 3px 0 ${({ theme }) => theme.shadow.black20};
  }

  .arial-regular {
    font-family: arial;
    font-weight: 400;
  }

  .tahoma-regular {
    font-family: tahoma;
    font-weight: 400;
  }

  ${mediaQueries.tablet`
    ${({ padding }) => padding && 'padding: 10px'};
    table{
      tr{
        td{
          font-size: 13px;
        }
        td,th{
          padding: 10px 5px;
        }
      }
    }
  `};
  ${mediaQueries.mobile`
    ${({ padding }) => padding && 'padding: 10px'};
    table{
      tr{
        td{
          font-size: 13px;
        }
        td,th{
          padding: 10px 0;
          min-width: 60px;
        }
      }
    }
  `};
`
class RichText extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isLoading: true
    }
  }

  componentDidMount() {
    this.asyncParseCmsClass()
  }

  asyncParseCmsClass = async () => {
    await parseCmsClass(this.props.text, document)
    this.setState({ isLoading: false })
  }

  render() {
    const { isLoading } = this.state
    return (
      <>
        {isLoading && <TransitionLoader />}

        <StyledText {...this.props} dangerouslySetInnerHTML={{ __html: this.props.text || '' }} />
      </>
    )
  }
}

export default RichText
